import React, { useContext } from 'react';
import MUITableHead from '@material-ui/core/TableHead';
import TableContext from '../context/TableContext';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import LinearProgress from '@material-ui/core/LinearProgress';
import styled from 'styled-components';

const StyledHeaderCell = styled.div`
  font-weight: bolder;
`;

const TableHead = () => {
  const { columns, loading } = useContext(TableContext);
  return (
    <MUITableHead>
      <TableRow>
        {columns?.map((column, index) => {
          if (column.label) {
            return (
              <TableCell key={`head_${column.id}`} align={column.align || 'left'}>
                <StyledHeaderCell>
                  {column.label}
                </StyledHeaderCell>
              </TableCell>
            );
          } else {
            return <TableCell key={`head_${column.id}`} />;
          }
        })}
      </TableRow>
      {loading && (
        <TableRow>
          <TableCell colSpan={columns.length} size={'small'} padding={'none'}>
            <LinearProgress style={{ width: '100%' }} />
          </TableCell>
        </TableRow>
      )}
    </MUITableHead>
  );
};

export default TableHead;
